const FrameRow = (props) => {
  const item = props.item;
  // const { item } = props;

  const handleChange = (id, field, newValue) => {
    props.onChange(id, field, newValue);
  };

  return (
    <div className="loadRow">
      <label className="table-label" htmlFor={item.id}>
        {item.descr}
      </label>
      <input
        className="valueInput"
        id={item.id}
        type="number"
        value={item.value}
        onChange={(e) =>
          handleChange(item.id, 'value', parseFloat(e.target.value))
        }
      />
    </div>
  );
};

export default FrameRow;
